// src/helpers/historyLogger.js
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";

export async function logTenantHistory(tenantId, log) {
  try {
    await addDoc(collection(db, "tenants", tenantId, "history"), {
      ...log,
      timestamp: serverTimestamp(),
    });
  } catch (err) {
    console.error("Error logging tenant history:", err);
  }
}
